import { api } from './api';

/** Würfel-Weg für LinkedIn-Texte (ADR 0290). Würfeln und Tauschen kosten nichts, nur Schreiben ruft Claude auf. */

export type WurfSlot = 'anlass' | 'karte' | 'beleg';

export interface WurfKarte {
  slot: WurfSlot;
  fach: string;
  id: string;
  text: string;
  art?: string;
  quelle?: string;
  antwort?: string;
  kunde_nennbar?: boolean;
}

export type WurfKarten = Record<WurfSlot, WurfKarte | null>;

export interface WurfAntwort {
  karten: WurfKarten;
  form: string;
  posttag: string;
  leere_faecher: string[];
  anzahl_karten: Record<string, number>;
}

export interface WurfPost {
  generation_id: number;
  text: string;
  form: string;
  fakt: string;
  behauptung: string;
  hinweise: string[];
  needs_review: boolean;
  vorbilder_anzahl: number;
}

export type Urteil = 'ja' | 'fast' | 'nein';

export const linkedinWurfApi = {
  wuerfeln: (strategyId: number, posttag: string) =>
    api.post<WurfAntwort>('/linkedin/wurf', { strategy_id: strategyId, posttag }),

  tauschen: (strategyId: number, posttag: string, slot: WurfSlot, ausser: string[]) =>
    api.post<{ karte: WurfKarte }>('/linkedin/wurf/tauschen', {
      strategy_id: strategyId, posttag, slot, ausser,
    }),

  schreiben: (strategyId: number, posttag: string, karten: WurfKarten, form: string) =>
    api.post<WurfPost>('/linkedin/wurf/schreiben', {
      strategy_id: strategyId,
      posttag,
      form,
      karten: { anlass: karten.anlass?.id ?? null, karte: karten.karte?.id ?? null, beleg: karten.beleg?.id ?? null },
    }),

  urteilen: (generationId: number, rating: Urteil, notes?: string) =>
    api.post<{ id: number; rating: Urteil }>(`/linkedin/posts/${generationId}/urteil`, { rating, notes }),
};
